import { authPost } from "@api/auth/auth";

import { ActionTestResponse } from "@pages/settings/types";
export const testAction = (deploymentId: string, actionId: number) => {
  return authPost<{}, ActionTestResponse>(
    `/api/agent/deployments/${deploymentId}/actions/${actionId}/test`,
    {}
  );
};
